export default "__VITE_ASSET__C1jeMFj1__"